import React, {Component} from 'react';
import ReactModal from 'react-modal';
import {Map} from 'immutable';
import config from 'config';
import {Wrapper} from 'system/wrapper';
import Spinner from 'spinner';
import {TendersList} from './components';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import Table from './components';

import close from 'images/general/close.svg';

const statuses = {
  'unsuccessful' : (
    <div style={{display: "inline-block"}}>Торги не відбулися</div>
  ),
  'active.tendering' : (
    <div style={{display: "inline-block"}}>Подання пропозицій</div>
  ),
  'active.auction' : (
    <div style={{display: "inline-block"}}>Аукціон</div>
  ),
  'complete' : (
    <div style={{display: "inline-block"}}>Завершена</div>
  ),
  'cancelled' : (
    <div style={{display: "inline-block"}}>Торги відмінено</div>
  ),
  'active.enquiries' : (
    <div style={{display: "inline-block"}}>Період уточнень</div>
  ),
  'active.qualification' : (
    <div style={{display: "inline-block"}}>Кваліфікація переможця</div>
  ),
  'active.awarded' : (
    <div style={{display: "inline-block"}}>Пропозиції розглянуті</div>
  ),
  'active.pre-qualification' : (
    <div style={{display: "inline-block"}}>Прекваліфікація</div>
  ),
  'active.pre-qualification.stand-still' : (
    <div style={{display: "inline-block"}}>Прекваліфікація (період оскарження)</div>
  )
}

export class TenderList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      tender: new Map()
    }
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(tender) {
    this.setState({
      modalOpen: true,
      tender
    })
  }

  closeModal() {
    this.setState({
      modalOpen: false
    })
  }

  render() {

    const { tenders } = this.props;

    if (tenders === undefined) {
          return (
            <Wrapper>
              <Spinner/>
            </Wrapper>
          )
        }

    return (
      <Table>
        <thead>
          <tr>
            <th>Сума закупівлі (грн.)</th>
            <th>Закупівельна організація</th>
            <th>Предмет закупівлі</th>
            <th>Дата публікації</th>
            <th>Стан</th>
          </tr>
        </thead>
        <tbody>
          {tenders.get('result').get('tender').map((tender, i) => (
            <tr onClick={() => this.openModal(tender)} key={tender.get('id')}>
              <td>{tender.get('tenderValue')} {tender.get('tenderCurrency')}</td>
              <td>{tender.get('organizationName')}</td>
              <td>{tender.get('title')}</td>
              <td>{new Date(tender.get('timeCreate')).toLocaleString('uk-UA', config.options)}</td>
              <td>{statuses[tender.get('status')]}</td>
            </tr>
          ))}
        </tbody>
        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.closeModal}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div  onClick={(event) => this.closeModal()}>
				         <img src={close} alt="закрити" />
              </div>
						</CloseModal>
            <ModalContent>
            <h3 style={{fontWeight: "bold"}}>Інформація про тендер</h3>
              <TendersList>
                <li>ID закупівлі: {this.state.tender.get('id')}</li>
                <li>Предмет закупівлі: {this.state.tender.get('title')}</li>
                <li>Закупівельна організація: {this.state.tender.get('organizationName')}</li>
                <li>Сума закупівлі: {this.state.tender.get('tenderValue')} {this.state.tender.get('tenderCurrency')}</li>
                <li>Дата публікації: {new Date(this.state.tender.get('timeCreate')).toLocaleString('uk-UA', config.options)}</li>
                <li>Стан: {statuses[this.state.tender.get('status')]}</li>
                <li>Дата початку тендера: {new Date(this.state.tender.get('tenderStartDate')).toLocaleString('uk-UA', config.options)}</li>
                <li>Дата закінчення тендера: {new Date(this.state.tender.get('tenderEndDate')).toLocaleString('uk-UA', config.options)}</li>
                <li>Контактна особа: {this.state.tender.get('contactPointName')}</li>
                <li>Остання дата модифіцації:  {this.state.tender.get('dateModified')}</li>
              </TendersList>
            </ModalContent>

          </Modal>
        </ReactModal>
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/system/information-center/procurements/tender-list.js